import useLoginCheck from "../hooks/useLoginCheck";
import Home from "../pages/Home";
import { useDispatch } from "react-redux";

const HomeContainer = () => {
  const dispatch = useDispatch();
  useLoginCheck(dispatch);
  return <Home />;
};

export default HomeContainer;
